/**
 * File lp-viewed-track.js.
 * Track first page viewed via Segment event
 */

var lpCurrentUrl = window.location.href;
var lpSourceUrl = document.referrer;
var lpAdId = null;
var referralId = getReferralId();

// Function to check if a URL contains 'chime.com' in its hostname
function containsChime(url) {
  try {
    var parsedUrl = new URL(url);
    return parsedUrl.hostname === 'chime.com' || parsedUrl.hostname.endsWith('.chime.com');
  } catch (e) {
    // Handle invalid URL
    return false;
  }
}

// If no referrer, set lpSourceUrl to lpCurrentUrl
if (!lpSourceUrl) {
  lpSourceUrl = lpCurrentUrl;
} else {
  // Check if 'chime.com' is in the hostname of the referrer URL
  if (containsChime(lpSourceUrl)) {
    // If 'chime.com' is found in the hostname, set lpSourceUrl to an empty string
    lpSourceUrl = '';
  }
}

// get ad param string
if(globalSearchParams.has('ad') || globalSearchParams.has('ad_id')) {
  lpAdId = globalSearchParams.toString();
}

function fpViewedTrack(lpRefCampaignId = null, lpRefBy = null, lpRefType = null, lpAffiliateName = null) {
  // if there is no fpViewed cookie this session, ensures lpSourceUrl is not empty before firing event
  if (document.cookie.indexOf("fpViewed") === -1 && lpSourceUrl !== '') {
    // trigger segment page event 'First Page Viewed'
    const properties = {
      referral_campaign_id: lpRefCampaignId,
      referred_by: lpRefBy,
      referral_type: lpRefType,
      affiliate_name: lpAffiliateName,
      ad_id: lpAdId,
      source_url: lpSourceUrl,
      url: lpCurrentUrl,
      current_url: lpCurrentUrl,
      starting_point: 'Landing Page'
    };

    fireAnalyticsEvent(Track.WebActionTriggered, {
      unique_id: 'first_entry_point',
    });

    segment(
      'page',
      'First Page Viewed',
      properties
    );

    // set fpViewed cookie
    document.cookie = "fpViewed=" + true + ";domain=" + globalCookieDomain + ";path=/;";
  }
}

// if not referral page or partners page, segment track function
if (referralId == '') {
  if (typeof window.waitForAnalyticsSDK === 'function') {
    window.waitForAnalyticsSDK().then(() => {
      fpViewedTrack();
    });
  } else {
    console.error('waitForAnalyticsSDK not yet defined');
  }
}
